import type { Enums } from "../types";

export { createAttendanceSections } from "./create-attendance-sections";
export { getAttendanceSourceTranslationKey } from "./get-attendance-source-translation-key";
export { getAttendanceStateColor } from "./get-attendance-state-color";
export { getAttendanceStateTranslationKey } from "./get-attendance-state-translation-key";
export { getAttendanceWorksiteColor } from "./get-attendance-worksite-color";
export { getAttendanceTypeTranslationKey } from "./get-attendance-type-translation-key";
export { getAttendanceWorksiteTranslationKey } from "./get-attendance-worksite-translation-key";
export { getAttendancesSeconds } from "./get-attendances-seconds";
export { getAutomaticBreak } from "./get-automatic-break";
export { getAutomaticBreakRestores } from "./get-automatic-break-restores";
export { getCanApproveAttendance } from "./get-can-approve-attendance";
export { getHasAllRequiredAcknowledgements } from "./get-has-all-required-acknowledgements";
export { getIsAttendanceEditable } from "./get-is-attendance-editable";
export { getMissingAcknowledgementDefinitionIds } from "./get-missing-acknowledgement-definition-ids";
export { getPendingCheckInSteps } from "./get-pending-check-in-steps";
export { getWorksiteMigrationItems } from "./get-worksite-migration-item";
export { groupAttendancesByUser } from "./group-attendances-by-user";
export {
	DEFAULT_AUTOMATIC_BREAK_BUFFER_MINUTES,
	getMissingBreakSeconds,
	getRequiredBreakSeconds,
	WORK_SECONDS_BEFORE_BREAK,
	WORK_SECONDS_BEFORE_LONG_BREAK,
} from "./legal-break";
export { mergeAttendanceSections } from "./merge-attendance-sections";
export { runCheckInSteps } from "./run-check-in-steps";

export const worksites: Array<Enums<"attendanceWorksiteType">> = [
	"home-office",
	"office",
	"project-site",
	"warehouse",
	"commute",
] as const;

/**
 * The worksites an attendance terminal can be paired to.
 *
 * A terminal hangs on a wall, so it books the place it hangs in and nothing else: a project site
 * is picked on the phone, a home office and a commute are nobody's terminal.
 */
export const terminalWorksites = ["office", "warehouse"] as const satisfies ReadonlyArray<
	Enums<"attendanceWorksiteType">
>;

export type TerminalWorksite = (typeof terminalWorksites)[number];
